module.exports = __webpack_public_path__ + "static/hydraulic_pump-90b80fb9efa9503965b0f28a3008010f.jpg";